import "./ButtonSubmit.scss";

export const ButtonSubmit = ({ text, onClick, className }) => {
  return (
    <>
      <button type="submit" onClick={onClick} className={className}>
        {text}
      </button>
    </>
  );
};
